import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../services/authentication.service';
import { HelperService } from 'src/app/services/helper.service';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { PushNotifications } from '@capacitor/push-notifications';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('vibration', [
      transition('shake <=> vibrate', animate('450ms ease-in-out', keyframes([
        style({ transform: 'translate3d(-7px, 0, 0)', offset: 0.1 }),
        style({ transform: 'translate3d(7px, 0, 0)', offset: 0.2 }),
        style({ transform: 'translate3d(-7px, 0, 0)', offset: 0.3 }),
        style({ transform: 'translate3d(7px, 0, 0)', offset: 0.4 }),
        style({ transform: 'translate3d(-7px, 0, 0)', offset: 0.5 }),
        style({ transform: 'translate3d(7px, 0, 0)', offset: 0.6 }),
        style({ transform: 'translate3d(-7px, 0, 0)', offset: 0.7 }),
        style({ transform: 'translate3d(7px, 0, 0)', offset: 0.8 }),
        style({ transform: 'translate3d(-7px, 0, 0)', offset: 0.9 }),
        style({ transform: 'translate3d(0, 0, 0)', offset: 1.0 }),
      ]))),
    ])
  ]
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  env: number;
  formState = 'shake';
  constructor(
    private builder           : FormBuilder,
    public authService        : AuthenticationService,
    private readonly helper   : HelperService,
    private readonly router   : Router,    
    private readonly platform : Platform
    
  ) {
    this.loginForm = this.builder.group({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    this.env = this.helper.getEnvironnement();
  }

  connexion(): void {
    this.authService.login(this.loginForm.value).subscribe({
      next : async response => {
        if(this.platform.is("capacitor")){
          await PushNotifications.register();
        }
      },
      error: error => {
        if (error.status === 401) {
          // La réponse est 401, changer l'état de l'animation
          this.formState = this.formState === 'shake' ? 'vibrate' : 'shake';
          setTimeout(() => {
            this.formState = 'shake'; // Réinitialiser l'état après une courte durée
          }, 300);
        }
      }
    });
  }

  forgotPassword(){
    this.router.navigateByUrl("forgotPassword");
  }

  redirect(){
    this.router.navigateByUrl("Inscription");
  }
}
